export const mustContainNumbersRegex = /\d/
